import React from 'react'

const IcInbox = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3332 9.99998H13.3332L11.6665 12.5H8.33317L6.6665 9.99998H1.6665M18.3332 9.99998V15C18.3332 15.442 18.1576 15.8659 17.845 16.1785C17.5325 16.4911 17.1085 16.6666 16.6665 16.6666H3.33317C2.89114 16.6666 2.46722 16.4911 2.15466 16.1785C1.8421 15.8659 1.6665 15.442 1.6665 15V9.99998M18.3332 9.99998L15.4582 4.25831C15.3202 3.98064 15.1075 3.74696 14.844 3.58355C14.5805 3.42014 14.2766 3.33348 13.9665 3.33331H6.03317C5.7231 3.33348 5.41922 3.42014 5.15571 3.58355C4.89219 3.74696 4.67949 3.98064 4.5415 4.25831L1.6665 9.99998" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default IcInbox
